export default "__VITE_ASSET__Cg7m2EoX__"